import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import BackToTop from '../../components/BackToTop/BackToTop';
import FlipCard from '../../components/FlipCard/FlipCard';
import './Tech.css';

const Tech = () => {
  useScrollAnimation();

  const techProducts = [
    {
      frontImage: "/logos/Powerpresent ai.jpg",
      frontTitle: "Powerpresent.ai",
      frontDescription: "AI presentation generation",
      backTitle: "Powerpresent.ai",
      backDescription: "Advanced AI platform that creates professional presentations in minutes. Perfect for businesses needing impactful visual storytelling.",
      link: "https://powerpresent.ai",
      linkText: "Explore",
      stats: ["AI Powered", "Time Saving", "Professional Results"]
    },
    {
      frontImage: "/logos/Yaara ai.jpg",
      frontTitle: "Yaara.ai",
      frontDescription: "AI writing assistant and content tools",
      backTitle: "Yaara.ai",
      backDescription: "Intelligent writing assistant that creates high-quality content for marketing, communications, and business documentation.",
      link: "https://www.yaara.ai/",
      linkText: "Explore",
      stats: ["Content Creation", "Marketing Tools", "Business Docs"]
    },
    {
      frontImage: "/logos/Sawda ai.jpg",
      frontTitle: "Sawda.ai",
      frontDescription: "Digital solutions for international trade",
      backTitle: "Sawda.ai",
      backDescription: "Streamlined digital platform that simplifies international trade processes, documentation, and supply chain management.",
      link: "https://www.sawda.ai/",
      linkText: "Explore",
      stats: ["Trade Solutions", "Supply Chain", "Documentation"]
    }
  ];

  const techOperations = [
    { location: "Global", company: "Powerpresent.ai", flag: "🌐" },
    { location: "Global", company: "Yaara.ai", flag: "🌐" },
    { location: "Global", company: "Sawda.ai", flag: "🌐" }
  ];

  return (
    <div className="tech-page">
      {/* Hero Section */}
      <section className="tech-hero">
        <div className="hero-background">
          <video className="hero-video" autoPlay muted loop playsInline>
            <source src="/video/tech-video.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Technology</h1>
            <p className="hero-subtitle">
              Driving Innovation Through Cutting-Edge Digital Solutions and AI-Powered Platforms
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">3</span>
                <span className="stat-label">AI Platforms</span>
              </div>
              <div className="stat">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Active Users</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Global Access</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>TechVentures Innovation</h2>
              <p>
                <strong>Trimline Group's TechVentures</strong> division drives innovation through our specialized digital platforms:{' '}
                <strong>PowerPresent.ai</strong> transforms how businesses create advanced presentations,{' '}
                <strong>Yaara.ai</strong> revolutionizes content creation with AI-powered writing tools,{' '}
                and <strong>Sawda.ai</strong> modernizes international trade through streamlined digital solutions.
              </p>
              <p>
                We integrate cutting-edge technology across all business sectors to enhance efficiency, 
                accelerate growth, and deliver measurable competitive advantages. Our platforms are designed 
                to simplify complex processes and empower businesses with intelligent automation.
              </p>
            </div>
            <div className="global-operations">
              <h3>Our Platforms</h3>
              <div className="operations-grid">
                {techOperations.map((operation, index) => (
                  <div className="operation-card" key={index}>
                    <span className="flag">{operation.flag}</span>
                    <h4>{operation.location}</h4>
                    <p>{operation.company}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tech Products Section */}
      <section className="divisions-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Technology Platforms</h2>
            <p>Innovative AI-powered solutions driving digital transformation</p>
          </div>
          
          <div className="flip-cards-grid">
            {techProducts.map((product, index) => (
              <FlipCard
                key={index}
                frontImage={product.frontImage}
                frontTitle={product.frontTitle}
                frontDescription={product.frontDescription}
                backTitle={product.backTitle}
                backDescription={product.backDescription}
                link={product.link}
                linkText={product.linkText}
                stats={product.stats}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tech-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business?</h2>
            <p>Discover how our AI-powered platforms can revolutionize your operations and drive growth.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">Get Started</a>
              <a href="/about" className="btn btn-secondary">View Demos</a>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default Tech;